/**
 * Sri Vani Sweets Homepage Interactions & Premium Effects
 */

document.addEventListener('DOMContentLoaded', function() {
  if (!document.body.classList.contains('srivani-body')) {
    return;
  }
  
  // 1. Premium Cursor Follower
  const follower = document.createElement('div');
  follower.classList.add('srivani-cursor-follower');
  document.body.appendChild(follower);

  let mouseX = 0;
  let mouseY = 0;
  let followerX = 0;
  let followerY = 0;

  document.addEventListener('mousemove', function(e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });

  // Smooth lerp follow loop
  function updateCursor() {
    // Lerp formula: current += (target - current) * factor
    followerX += (mouseX - followerX) * 0.15;
    followerY += (mouseY - followerY) * 0.15;
    follower.style.left = followerX + 'px';
    follower.style.top = followerY + 'px';
    requestAnimationFrame(updateCursor);
  }
  updateCursor();

  // Scale cursor follower on hovering clickable assets
  const clickables = document.querySelectorAll('a, button, .srivani-variant-pill, .srivani-qty-btn, .srivani-moment-tab, .srivani-category-circle, .srivani-timeline-node');
  clickables.forEach(function(item) {
    item.addEventListener('mouseenter', () => follower.classList.add('hovering'));
    item.addEventListener('mouseleave', () => follower.classList.remove('hovering'));
  });

  document.querySelectorAll('.srivani-variant-pills').forEach(function(group) {
    group.addEventListener('click', function(event) {
      const pill = event.target.closest('.srivani-variant-pill');
      if (!pill || !group.contains(pill)) return;
      group.querySelectorAll('.srivani-variant-pill').forEach(item => item.classList.remove('active'));
      pill.classList.add('active');
    });
  });

  // Hide follower when mouse leaves window
  document.addEventListener('mouseleave', () => {
    follower.style.display = 'none';
  });
  document.addEventListener('mouseenter', () => {
    follower.style.display = '';
  });


  // 2. 3D Parallax Tilt Effect on Product Cards
  const cards = document.querySelectorAll('.srivani-product-card, .srivani-spotlight-card');
  cards.forEach(function(card) {
    card.addEventListener('mousemove', function(e) {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left; // x coordinate inside element
      const y = e.clientY - rect.top;  // y coordinate inside element
      
      const width = rect.width;
      const height = rect.height;
      
      // Calculate tilt angles (-12 to 12 degrees)
      const tiltX = ((y / height) - 0.5) * -24;
      const tiltY = ((x / width) - 0.5) * 24;
      
      card.style.transform = `perspective(1000px) rotateX(${tiltX}deg) rotateY(${tiltY}deg) translateY(-8px)`;
      card.style.transition = 'transform 0.05s ease';
    });

    card.addEventListener('mouseleave', function() {
      card.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) translateY(0px)';
      card.style.transition = 'transform 0.5s ease';
    });
  });


  // 3. Scroll Parallax background effect for therapist banner
  const parallaxBgs = document.querySelectorAll('.srivani-therapist-bg');
  window.addEventListener('scroll', function() {
    const scrolled = window.pageYOffset;
    parallaxBgs.forEach(function(bg) {
      // Get offset of element relative to viewport
      const parent = bg.parentElement;
      const parentRect = parent.getBoundingClientRect();
      const parentOffsetTop = parentRect.top + scrolled;
      
      // Check if element is in view
      if (scrolled + window.innerHeight > parentOffsetTop && scrolled < parentOffsetTop + parentRect.height) {
        // Shift background y position based on scroll offset
        const yOffset = (scrolled - parentOffsetTop) * 0.15;
        bg.style.transform = `translateY(${yOffset}px) scale(1.1)`;
      }
    });
  });


  // 4. Hero Slideshow Auto-play
  const slides = document.querySelectorAll('.srivani-hero-slide');
  let currentSlide = 0;
  const slideInterval = 5000;

  function nextSlide() {
    if (slides.length === 0) return;
    slides[currentSlide].classList.remove('active');
    currentSlide = (currentSlide + 1) % slides.length;
    slides[currentSlide].classList.add('active');
  }

  if (slides.length > 0) {
    setInterval(nextSlide, slideInterval);
  }


  // 5. "Flavours for Every Moment" Interactive Category Tabs
  const tabContainer = document.querySelector('.srivani-moments-section');
  if (tabContainer) {
    const tabs = tabContainer.querySelectorAll('.srivani-moment-tab');
    const grids = tabContainer.querySelectorAll('.srivani-moment-grid');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        const targetCategory = this.getAttribute('data-category');
        
        // Toggle active tab
        tabs.forEach(t => t.classList.remove('active'));
        this.classList.add('active');

        // Toggle active grid
        grids.forEach(function(grid) {
          if (grid.getAttribute('id') === targetCategory) {
            grid.classList.add('active');
          } else {
            grid.classList.remove('active');
          }
        });
      });
    });
  }


  // 6. Sticky Header
  const header = document.querySelector('.srivani-header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 40) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });
  }


  // 7. Interactive Legacy Timeline: "A Sweetness Perfected Over Time"
  document.querySelectorAll('[data-srivani-timeline]').forEach(function(timeline) {
    const nodes = timeline.querySelectorAll('.srivani-timeline-node');
    const progressLine = timeline.querySelector('[data-timeline-progress]');
    const timelineTitle = timeline.querySelector('[data-timeline-title]');
    const timelineDesc = timeline.querySelector('[data-timeline-desc]');
    const timelineImg = timeline.querySelector('[data-timeline-img]');
    const card = timeline.querySelector('[data-timeline-card]');

    if (nodes.length === 0 || !progressLine || !timelineTitle || !timelineDesc || !timelineImg || !card) {
      return;
    }

    nodes.forEach(function(node) {
      node.addEventListener('click', function() {
        const index = parseInt(this.getAttribute('data-index'), 10);
        const percentage = nodes.length > 1 ? (index / (nodes.length - 1)) * 100 : 100;
        progressLine.style.width = percentage + '%';

        nodes.forEach(n => n.classList.remove('active'));
        this.classList.add('active');

        card.style.opacity = '0';
        card.style.transform = 'translateY(10px)';
        card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';

        const selectedNode = this;
        setTimeout(() => {
          timelineTitle.textContent = selectedNode.dataset.title || '';
          timelineDesc.textContent = selectedNode.dataset.desc || '';
          timelineImg.src = selectedNode.dataset.img || timelineImg.src;
          timelineImg.alt = selectedNode.dataset.title || '';

          card.style.opacity = '1';
          card.style.transform = 'translateY(0)';
        }, 300);
      });
    });
  });

  // 8. Heritage-style collection grid width shrink
  document.querySelectorAll('.srivani-heritage-collections').forEach(function(section) {
    section.style.width = '100%';

    const updateCollectionWidth = function() {
      if (window.innerWidth <= 749) {
        section.style.width = '100%';
        return;
      }

      const rect = section.getBoundingClientRect();
      const topThreshold = rect.height * 0.3;
      const scrolledPast = -rect.top;

      if (scrolledPast <= 0) {
        section.style.width = '100%';
      } else if (scrolledPast >= topThreshold) {
        section.style.width = '80%';
      } else {
        const width = 100 - (scrolledPast / topThreshold) * 20;
        section.style.width = width + '%';
      }
    };

    window.addEventListener('scroll', updateCollectionWidth, { passive: true });
    window.addEventListener('resize', updateCollectionWidth);
    updateCollectionWidth();
  });

  // 9. Heritage-style world delivery width expand
  document.querySelectorAll('.srivani-world-delivery-section').forEach(function(section) {
    section.style.width = window.innerWidth > 749 ? '80%' : '100%';

    const updateDeliveryWidth = function() {
      if (window.innerWidth <= 749) {
        section.style.width = '100%';
        return;
      }

      const rect = section.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const visibleAmount = viewportHeight - rect.top;
      const startThreshold = rect.height * 0.3;
      const endThreshold = rect.height * 0.6;

      if (visibleAmount <= startThreshold) {
        section.style.width = '80%';
      } else if (visibleAmount >= endThreshold) {
        section.style.width = '100%';
      } else {
        const progress = (visibleAmount - startThreshold) / (endThreshold - startThreshold);
        section.style.width = (80 + progress * 20) + '%';
      }
    };

    window.addEventListener('scroll', updateDeliveryWidth, { passive: true });
    window.addEventListener('resize', updateDeliveryWidth);
    updateDeliveryWidth();
  });

  // 10. Heritage-style sticky story image reveal
  const storyRevealSections = document.querySelectorAll('[data-srivani-story-reveal]');
  if (storyRevealSections.length > 0) {
    const getHeaderOffset = function() {
      const header = document.querySelector('.srivani-header, .site-header, .header-wrapper, header');
      const announcement = document.querySelector('.srivani-topbar, .announcement-bar');
      const headerHeight = header ? header.offsetHeight : 0;
      const announcementHeight = announcement ? announcement.offsetHeight : 0;
      return headerHeight + announcementHeight;
    };

    storyRevealSections.forEach(function(section) {
      const container = section.querySelector('[data-story-container]');
      const wrapper = section.querySelector('[data-story-wrapper]');
      const frameWrapper = section.querySelector('[data-story-frame]');
      const textContent = section.querySelector('[data-story-text]');

      if (!container || !wrapper || !frameWrapper || !textContent) {
        return;
      }

      let ticking = false;

      const adjustWrapperPosition = function() {
        const headerOffset = getHeaderOffset();
        wrapper.style.setProperty('--srivani-story-sticky-top', headerOffset + 'px');
        wrapper.style.height = `calc(100vh - ${headerOffset}px)`;
      };

      const updateScrollReveal = function() {
        ticking = false;

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const containerTop = container.getBoundingClientRect().top + scrollTop;
        const scrollableDistance = Math.max(1, container.offsetHeight - window.innerHeight);
        const scrollDistance = Math.max(0, scrollTop - containerTop);
        const scrollProgress = Math.min(1, scrollDistance / scrollableDistance);
        const scaleFactor = 1 + scrollProgress;
        const textOpacity = scrollProgress >= 0.5 ? Math.min(1, (scrollProgress - 0.5) * 2) : 0;

        frameWrapper.style.transform = `scale(${scaleFactor})`;
        textContent.style.opacity = textOpacity;
        textContent.style.transform = `translateY(${(1 - textOpacity) * 24}px)`;
      };

      const requestUpdate = function() {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(updateScrollReveal);
        }
      };

      adjustWrapperPosition();
      updateScrollReveal();

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', function() {
        adjustWrapperPosition();
        updateScrollReveal();
      });

      setTimeout(function() {
        adjustWrapperPosition();
        updateScrollReveal();
      }, 120);
    });
  }

  // 11. Auto-sliding Carousels for Stories, Featured Delights, and In the Media
  function initAutoCarousels() {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      setTimeout(initAutoCarousels, 150);
      return;
    }

    var $ = jQuery;

    // 1. Stories Carousel (Instagram Reels)
    var $instaCarousel = $('.srivani-insta-row-carousel');
    if ($instaCarousel.length && !$instaCarousel.hasClass('slick-initialized')) {
      $instaCarousel.slick({
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.2,
              slidesToScroll: 1,
              dots: true
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1.1,
              slidesToScroll: 1,
              dots: true
            }
          }
        ]
      });
    }

    // 2. Featured Delights Carousel (Curated Grid)
    var $curatedCarousel = $('.srivani-curated-carousel');
    if ($curatedCarousel.length && !$curatedCarousel.hasClass('slick-initialized')) {
      $curatedCarousel.slick({
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3500,
        speed: 600,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.3,
              slidesToScroll: 1,
              dots: true
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1.1,
              slidesToScroll: 1,
              dots: true
            }
          }
        ]
      });
    }

    // 3. In the Media Carousel (Spotlight)
    var $spotlightCarousel = $('.srivani-spotlight-carousel');
    if ($spotlightCarousel.length && !$spotlightCarousel.hasClass('slick-initialized')) {
      $spotlightCarousel.slick({
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.2,
              slidesToScroll: 1,
              dots: true
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1.1,
              slidesToScroll: 1,
              dots: true
            }
          }
        ]
      });
    }
  }

  initAutoCarousels();

});


  
  // Dynamic Weight Pill Click & Inline Style Switcher
  document.addEventListener('click', function(event) {
    const pill = event.target.closest('.srivani-variant-pill');
    if (!pill) return;

    const card = pill.closest('.srivani-product-card');
    if (!card) return;

    // 1. Toggle active state and update inline background/border colors
    const allPills = card.querySelectorAll('.srivani-variant-pill');
    allPills.forEach(function(p) {
      p.classList.remove('active');
      p.style.background = '#f59e0b';
      p.style.borderColor = '#f59e0b';
      p.style.color = '#ffffff';
    });

    pill.classList.add('active');
    pill.style.background = '#d32f2f';
    pill.style.borderColor = '#d32f2f';
    pill.style.color = '#ffffff';

    // 2. Check internal radio input if present
    const radio = pill.querySelector('input[type="radio"]');
    if (radio) {
      radio.checked = true;
    }

    // 3. Update hidden form input[name="id"]
    const variantId = pill.getAttribute('data-variant-id');
    const form = card.querySelector('form');
    if (form && variantId) {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) {
        idInput.value = variantId;
      }
    }

    // 4. Instantly update price text in the same card
    const priceVal = pill.getAttribute('data-variant-price') || pill.getAttribute('data-price');
    if (priceVal) {
      const priceEl = card.querySelector('.srivani-pc-price');
      if (priceEl) {
        priceEl.textContent = priceVal;
      }
    }
  });
